import React from 'react'
import PropTypes from 'prop-types'
import './ReadOnlyField.css'

const ReadOnlyField = props => <p className='ReadOnly'> {props.value} </p>

ReadOnlyField.propTypes = {
    value: PropTypes.any.isRequired
}

export default ReadOnlyField
